<template>
  <div>
    <NewProvider @created="getProviders" />
    <b-modal
      size="lg"
      no-close-on-backdrop
      hide-footer
      id="import"
      title="IMPORTAR FORNECEDOR(ES)"
    >
      <Import @success="getProviders" />
    </b-modal>
    <div class="row">
      <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
        <h1 class="title-pages">FORNECEDORES</h1>
      </div>
      <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 text-right">
        <v-btn
          v-if="
            permission('write', 'financial_provider') ||
            permission('write', 'provider')
          "
          @click="$bvModal.show('new_provider')"
          class="btn-add m-1"
          ><i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR</v-btn
        >
        <v-btn
          v-if="
            permission('write', 'financial_provider') ||
            permission('write', 'provider')
          "
          @click="$bvModal.show('import')"
          class="btn-dateils m-1"
          ><i class="fas fa-file-upload mr-2 text-twenty"></i> IMPORTAR
          FORNECEDOR(ES)</v-btn
        >
      </div>
      <div class="col-md-3">
        <label>Status</label>
        <select
          v-model="active"
          class="form-control"
          @change="handleChangeFilter"
        >
          <option
            v-for="(item, key) in active_filters"
            :key="key"
            :value="item.value"
          >
            {{ item.text }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <label>Classificação</label>
        <select
          v-model="classification_id"
          class="form-control"
          @change="handleChangeFilter"
        >
          <option value="">TODAS</option>
          <option
            v-for="(item, key) in classifications"
            :key="key"
            :value="item.id"
          >
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="col-md-6">
        <label>Pesquisar</label>
        <input
          type="text"
          class="form-control"
          v-model="search"
          @input="handleInputSearch"
        />
      </div>
    </div>
    <div class="v-clean p-5 text-center" v-show="providers.length == 0">
      <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
    </div>
    <v-data-table
      v-show="providers.length > 0"
      dense
      hide-default-footer
      disable-pagination
      :headers="headers"
      :items="providers"
      :search="search"
      :footer-props="{
        'items-per-page-options': [50, 75, 100],
        'items-per-page-text': 'Mostrar',
      }"
    >
      <template #[`item.active`]="{ item }">
        {{ item.active == 1 ? "ATIVO" : "INATIVO" }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          v-if="
            permission('edit', 'financial_provider') ||
            permission('edit', 'provider')
          "
          small
          @click="$router.push({ name: 'provider', params: { id: item.id } })"
          class="btn-edit m-1"
        >
          <i class="fas fa-pen mr-2 text-twenty"></i>
          EDITAR
        </v-btn>
      </template>
    </v-data-table>
    <div class="mt-5">
      <b-pagination
        align="center"
        v-if="providers.length > 0"
        @input="getProviders()"
        v-model="page"
        :total-rows="total"
        :per-page="25"
      />
    </div>
    <errors-messages :errors="errors" />
  </div>
</template>

<script>
import NewProvider from "./NewProvider.vue";

import Import from "./Import";

import ErrorsMessages from "../../Components/ErrorsMessages.vue";

import permission from "../../../lib/permission";

import api from "../../../services/api";

export default {
  name: "Providers",

  components: { NewProvider, Import, ErrorsMessages },

  data() {
    return {
      errors: [],
      loading: false,

      active_filters: [
        { text: "ATIVO", value: "1" },
        { text: "INATIVO", value: "0" },
      ],
      active: "1",
      page: 1,
      total: 0,
      classifications: [],
      classification_id: "",

      search: "",
      headers: [
        { text: "NOME", value: "company_name" },
        { text: "CLASSIFICAÇÃO", value: "classification_name" },
        { text: "CPF/CNPJ", value: "cpf_cnpj" },
        { text: "STATUS", value: "active" },
        { text: "AÇÕES", value: "actions" },
      ],
      providers: [],
    };
  },

  created() {
    this.getProviders();
    this.getClassifications();
  },

  methods: {
    permission,
    handleInputSearch() {
      this.page = 1;
      this.getProviders();
    },
    handleChangeFilter() {
      this.page = 1;
      this.getProviders();
    },
    async retrieve() {
      if (this.errors.length === 0) this.getProviders();
      if (this.errors.length === 0) this.getClassifications();
    },

    async getProviders() {
      try {
        this.loading = true;

        const params = {
          active: this.active,
          classification_id: this.classification_id,
          page: this.page,
          search: this.search,
        };
        const response = await api.get("/rest-home/providers/paginate", {
          params,
        });
        const { error, errors, providers, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.providers = providers;
          this.total = total;
        }
        this.loading = false;
        this.$bvModal.hide("import");
      } catch (error) {
        console.log(error);
      }
    },

    async getClassifications() {
      try {
        this.loading = true;

        const params = { active: "1" };
        const response = await api.get("/rest-home/providers/classifications", {
          params,
        });
        const { error, errors, classifications } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.classifications = classifications;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style>
</style>